document.addEventListener('DOMContentLoaded', function () {
  const productHandle = window.location.pathname.split('/products/')[1];
  if (!productHandle) return;

  fetch(`/products/${productHandle}.js`)
    .then(res => res.json())
    .then(product => {
      const variants = product.variants;

      function updateSoldout() {
        const selectedColor = document.querySelector('[data-option-type="color"][data-selected="true"]')?.dataset.value;

        document.querySelectorAll('[data-option-type="button"], [data-option-type="default"]').forEach(btn => {
          const size = btn.dataset.value;

          const available = variants.some(v => {
            const hasSize = v.options.includes(size);
            const hasColor = !selectedColor || v.options.includes(selectedColor);
            return hasSize && hasColor && v.available;
          });

          if (available) {
            btn.classList.remove('is-soldout');
          } else {
            btn.classList.add('is-soldout');
          }
        });

        document.querySelectorAll('[data-option-type="color"]').forEach(btn => {
          const color = btn.dataset.value;
          const available = variants.some(v => v.options.includes(color) && v.available);

          if (available) {
            btn.classList.remove('is-soldout');
            btn.closest('.sf__tooltip-item')?.classList.remove('is-soldout');
          } else {
            btn.classList.add('is-soldout');
            btn.closest('.sf__tooltip-item')?.classList.add('is-soldout');
          }
        });

        document.querySelectorAll('.sf__tooltip-item.is-soldout').forEach(item => {
          item.addEventListener('click', function(e) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }, true);
        });
      }

      updateSoldout();

      document.querySelectorAll('[data-option-type]').forEach(btn => {
        btn.addEventListener('click', function () {
          setTimeout(updateSoldout, 100);
        });
      });
    });
});
